var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import _ from 'lodash';
import TableHeaderToolTip from '../../../common/components/TableHeaderToolTip.vue';
import DistriDialog from './AddGoodDialog.vue';
var GoodsList = (function (_super) {
    __extends(GoodsList, _super);
    function GoodsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectRows = [];
        _this.frontData = [];
        return _this;
    }
    GoodsList.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    GoodsList.prototype.addGoods = function () {
        var _this = this;
        var dialog = this['$dialog'](DistriDialog, {
            data: {
                addedDatas: this.listData,
                type: this.type,
            },
        }, {
            title: '添加货品',
            width: 900,
            height: 550,
        });
        dialog.instance.$on("submit", function (res) {
            _this.$emit('changeGoodsSelect', _this.type, res);
            _this.selectRows = [];
            _this.createPager();
        });
    };
    GoodsList.prototype.deleteGoods = function () {
        var _this = this;
        if ((this.selectRows || []).length === 0) {
            return this.$message.warning("请选择货品");
        }
        this.$confirm("请确认是否删除该货品", '提示').then(function (res) {
            var tempData = _.cloneDeep(_this.listData);
            _this.selectRows.forEach(function (select) {
                tempData.forEach(function (item) {
                    var goodsType = 'goods_format_id';
                    if (select[goodsType] == item[goodsType]) {
                        var index = tempData.indexOf(item);
                        tempData.splice(index, 1);
                    }
                });
            });
            _this.$emit('changeGoodsSelect', _this.type, tempData);
            _this.createPager();
        }, function (err) { });
    };
    GoodsList.prototype.pageChange = function (pager) {
        this.createPager(pager);
    };
    GoodsList.prototype.createPager = function (pager) {
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var frontData = [];
        var startIndex = pager.start;
        var endIndex = pager.start + pager.limit - 1;
        for (var i = startIndex; i <= endIndex; i++) {
            if (!this.listData[i]) {
                break;
            }
            frontData.push(this.listData[i]);
        }
        this.frontData = frontData;
    };
    GoodsList.prototype.validTable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isValid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this['$validator'].validateScopes()];
                    case 1:
                        isValid = _a.sent();
                        return [2, isValid];
                }
            });
        });
    };
    __decorate([
        Prop({
            required: true,
        })
    ], GoodsList.prototype, "type", void 0);
    __decorate([
        Prop({
            required: true,
        })
    ], GoodsList.prototype, "mode", void 0);
    __decorate([
        Prop()
    ], GoodsList.prototype, "listData", void 0);
    GoodsList = __decorate([
        Component({
            components: {
                TableHeaderToolTip: TableHeaderToolTip
            },
            watch: {
                listData: {
                    immediate: true,
                    handler: function (newValue, oldVal) {
                        this.createPager();
                    }
                }
            },
            methods: {
                renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: "<div>赠品数量：所有客户总共可领取的。</div><div>每单可赠送一件，赠完后不可再领取赠品。</div>",
                            placement: "bottom"
                        }
                    }, '数量');
                }
            }
        })
    ], GoodsList);
    return GoodsList;
}(Vue));
export default GoodsList;
